const userPaths = {
  basePath: "user",
};

export default userPaths;
